// src/hooks/ProtectedRoute.jsx
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import toast from 'react-hot-toast';

const ProtectedRoute = ({ requiredRole = null, children }) => {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (!user) {
        // Redirect to /register with return URL
        toast.error('Please login or register to access this course');
        navigate('/login', { state: { from: location }, replace: true });
        return;
      }

      const role = user.app_metadata?.role || 'user';
      if (requiredRole && role !== requiredRole) {
        navigate('/dashboard', { replace: true });
        return;
      }

      setAuthorized(true);
      setLoading(false);
    };

    checkAuth();
  }, [navigate, location, requiredRole]);

  if (loading) {
    return <div className="text-center p-8 text-lg">Checking access...</div>;
  }

  return authorized ? children : null;
};

export default ProtectedRoute;
